import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import cn from 'classnames';
import { faAnglesRight, faArrowLeft, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCurrentUser, logoutUser } from '@redux/features/authSlice';
import { getLocations } from '@redux/features/locationsSlice';
import SessionStorageUtils from 'utils/SessionStorageUtils';
import { SessionStorageKeys } from 'constants/sessionStorageKeys';
import { Button } from 'components/Button';
import styles from 'pages/Locations/Locations.scss';

export const Choose = () => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.locations);
  const [availableLocations, setAvailableLocations] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (SessionStorageUtils.getData(SessionStorageKeys.LOCATION)) {
      navigate('/', { replace: true });
    }
    if (!user && isAuthenticated) {
      dispatch(getCurrentUser());
    }
  }, []);

  useEffect(() => {
    if (user && locations.length > 0) {
      const filteredLocations = locations.filter(({ id }) => {
        if (user?.role === 3) return true;
        const userLocationIDs = user?.locations.map(({ id }) => id) || [];
        return userLocationIDs.includes(id);
      });

      setAvailableLocations(filteredLocations);
    }
  }, [user, locations]);

  useEffect(() => {
    if (availableLocations?.length === 1 && user?.role !== 3) {
      const { id, name, transliteration, availableRoutes } = availableLocations[0];
      handleLocationClick(id, name, transliteration, availableRoutes);
      navigate(`/${transliteration}/panel`, { replace: true });
    }
  }, [availableLocations]);

  const handleLocationClick = (id, name, transliteration, availableRoutes = []) => {
    SessionStorageUtils.setData(SessionStorageKeys.LOCATION, {
      id,
      name,
      transliteration,
      availableRoutes,
    });
  };

  const handleAdminEntrance = () => {
    SessionStorageUtils.setData(SessionStorageKeys.LOCATION, {
      admin: true,
      name: 'Загальне керування',
      transliteration: '',
      availableRoutes: [1, 2, 3, 4, 5, 6],
    });
  };

  const logout = () => dispatch(logoutUser());

  return (
    <>
      <div className={cn(styles.header, styles.choose)}>
        {user && <h1 className={styles.title}>Вітаємо, {user?.name}!</h1>}
        {availableLocations?.length !== 0 && <span className={styles.subtitle}>Оберіть доступну опцію</span>}
      </div>
      <Button className={styles.btn} onClick={logout} noStyle>
        <FontAwesomeIcon className={styles.icon} icon={faArrowLeft} />
        Змінити акаунт
      </Button>
      <div className={styles.locations}>
        {user?.locations.length === 0 && user?.role === 3 && (
          <Link className={cn(styles.location, styles.main)} to='/panel' onClick={handleAdminEntrance}>
            Загальний доступ
            <span className={styles.line} />
            <span className={styles.line} />
            <span className={styles.line} />
            <span className={styles.line} />
            <span className={styles.line} />
            <FontAwesomeIcon className={styles.arrow} icon={faAnglesRight} />
          </Link>
        )}
        {availableLocations?.map(({ id, name, transliteration, availableRoutes }) => (
          <Link
            className={styles.location}
            name={name}
            to={`/${transliteration}/panel`}
            key={id}
            onClick={() => handleLocationClick(id, name, transliteration, availableRoutes)}
          >
            {name}
            <span className={styles.line} />
            <span className={styles.line} />
            <span className={styles.line} />
            <FontAwesomeIcon className={styles.arrow} icon={faAnglesRight} />
          </Link>
        ))}
        {availableLocations?.length === 0 && user?.role !== 3 && (
          <div className={styles.noAccess}>
            <p className={styles.title}>
              <FontAwesomeIcon className={styles.icon} icon={faExclamationTriangle} />
              Доступ до системи відсутній
            </p>
            <p className={styles.text}>
              Ваш обліковий запис ще не має доступу до системи. Це може бути пов’язано з тим, що ви щойно
              зареєструвались або доступ ще не надано.
            </p>
            <p className={styles.text}>
              У разі затримки з наданням доступу або виникнення питань, рекомендуємо звернутися до адміністратора вашого
              підрозділу або до служби технічної підтримки для уточнення статусу доступу.
            </p>
          </div>
        )}
      </div>
    </>
  );
};
